
function initForm() {

    let inputs = document.querySelectorAll('.form-control');

    inputs.forEach(input => {
        input.addEventListener('blur', function() {
            if(input.value != ""){
                input.closest('.input-container').classList.add("is-active");
            } else {
                input.closest('.input-container').classList.remove("is-active");
            }
        });
    });


}

// Export the navigation init function
export default initForm;



// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/open.test/frontend/source/utilities/form.js